import React, { useState } from "react";
import { Link } from "react-router-dom";
import { LocalWebLink } from "../Config/constants";
import { HireLink } from "../Config";
import { PopupButton } from "react-calendly";
import { KeyboardArrowDown } from "@mui/icons-material";

const Header = () => {
     const [toolsOpen, setToolsOpen] = useState(false);

     return (
          <header className="header" id="header">
               <div className="content-center">
                    <div className="__header-content">
                         <div className="__left">
                              <Link to="/" className="logo">
                                   <img src={require("../assets/images/logo.png")} alt="logo" />
                              </Link>
                         </div>

                         <div className="__right">
                              <ul className="nav">
                                   {LocalWebLink.map((val, index) => (
                                        <li 
                                             className={`nav-item ${val.isDropdown ? '__dropdown-item' : ''}`} 
                                             key={index}
                                             onMouseEnter={() => val.isDropdown && setToolsOpen(true)}
                                             onMouseLeave={() => val.isDropdown && setToolsOpen(false)}
                                        >
                                             {val.isDropdown ? (
                                                  <div className="__dropdown-wrapper">
                                                       <Link 
                                                            to={val.linkUrl} 
                                                            className="nav-link __dropdown-trigger"
                                                            onClick={() => setToolsOpen(!toolsOpen)}
                                                       >
                                                            <span>{val.icon}</span>
                                                            {val.name}
                                                            <KeyboardArrowDown className={`__arrow-icon ${toolsOpen ? 'rotated' : ''}`} />
                                                       </Link>

                                                       <div className={`__tools-dropdown ${toolsOpen ? 'open' : ''}`}>
                                                            {val.subLinks?.map((sub, sIdx) => (
                                                                 <Link 
                                                                      key={sIdx} 
                                                                      to={sub.linkUrl} 
                                                                      className="__dropdown-sublink"
                                                                      onClick={() => setToolsOpen(false)}
                                                                 >
                                                                      <div className="__sublink-header">
                                                                           <span className="__sublink-title">{sub.name}</span>
                                                                           {sub.badge && <span className="__sublink-badge">{sub.badge}</span>}
                                                                      </div>
                                                                      {sub.desc && <p className="__sublink-desc">{sub.desc}</p>}
                                                                 </Link>
                                                            ))}
                                                       </div>
                                                  </div>
                                             ) : val.link ? (
                                                  <Link to={val.linkUrl} className="nav-link">
                                                       <span>{val.icon}</span>
                                                       {val.name}
                                                  </Link>
                                             ) : (
                                                  <a href={val.linkUrl} className="nav-link">
                                                       <span>{val.icon}</span>
                                                       {val.name}
                                                  </a>
                                             )}
                                        </li>
                                   ))}
                              </ul>

                              <PopupButton
                                   url={HireLink}
                                   rootElement={document.getElementById("root")}
                                   text="Hire Me"
                                   className="btn" />

                         </div>

                    </div>
               </div>

          </header>
     );
};

export default Header;
